<div class="ig-select" [class.ig-disabled]="disabled" (keydown)="onKeydown($event)">
  <button #trigger type="button" class="ig-trigger" [id]="id || null" [disabled]="disabled"
    [attr.aria-expanded]="open" [attr.aria-controls]="panelId" aria-haspopup="listbox"
    (click)="toggle()">
    <span class="ig-value" [class.ig-placeholder]="!selectedItem">{{selectedLabel || placeholder}}</span>
    <span class="ig-actions">
      <span *ngIf="clearable && selectedItem" role="button" aria-label="Limpiar selección" class="ig-clear" (click)="clear($event)">×</span>
      <span class="ig-chevron" [class.ig-rotated]="open"></span>
    </span>
  </button>
  <div *ngIf="open" class="ig-panel" [id]="panelId" role="listbox"
    [style.top.px]="panelPosition.top" [style.left.px]="panelPosition.left"
    [style.width.px]="panelPosition.width" [style.maxHeight.px]="panelPosition.maxHeight">
    <div class="ig-search" *ngIf="searchable">
      <input #searchInput type="search" [value]="term" [placeholder]="searchPlaceholder"
        [attr.aria-label]="searchPlaceholder" (input)="searchChanged(searchInput.value)" autocomplete="off">
    </div>
    <div class="ig-options" [style.maxHeight.px]="panelPosition.maxHeight - (searchable ? 56 : 0)">
      <ng-container *ngFor="let group of groups">
        <div class="ig-group" *ngIf="groupBy">{{group.name}}</div>
        <button type="button" class="ig-option" role="option" *ngFor="let item of group.items"
          [class.is-selected]="isActive(item)" [class.is-highlighted]="isHighlighted(item)"
          [attr.aria-selected]="isActive(item)" (mouseenter)="activeIndex = filtered.indexOf(item)"
          (mousedown)="optionMouseDown($event, item)" (click)="optionClick($event, item)">
          <span>{{itemLabel(item)}}</span><span *ngIf="isActive(item)" aria-hidden="true">✓</span>
        </button>
      </ng-container>
      <div *ngIf="!filtered.length" class="ig-empty">{{notFoundText}}</div>
    </div>
  </div>
</div>
